<template>
    <form-container :headerText="title" :width="400" action="editLiga"
                    :valid-actions="['editLiga']" @save="save()">
        <div v-if="rules" class="px-7 pb-3">
            <!--<v-text-field v-model="dataObject.id" :rules="[rules.required]"
                          label="Liganummer" :disabled="currentData!==null">
            </v-text-field>-->
            <v-text-field v-model="dataObject.name" :rules="[rules.required]"
                          label="Liganame Auswahlliste">
            </v-text-field>
            <v-text-field v-model="dataObject.nameFull" :rules="[rules.required]"
                          label="Liganame voll">
            </v-text-field>
            <v-radio-group v-model="dataObject.type" :rules="[rules.required]">
                <v-radio v-for="(type, n) in types"
                        :key="n"
                        :label="type.label"
                        :value="type.value"
                ></v-radio>
            </v-radio-group>
            <v-text-field v-model="dataObject.sort" :rules="[rules.required]"
                          label="Position für Sortierung in Auswahlliste" type="number">
            </v-text-field>
            <v-checkbox v-model="dataObject.isCup" hide-details
                        label="ist Cup-Bewerb" color="primary">
            </v-checkbox>
            <v-checkbox v-model="dataObject.keineDoppelstartKontrolle" hide-details
                        :disabled="dataObject.isCup"
                        label="keine Doppelstart-Kontrolle" color="primary">
            </v-checkbox>
            <v-checkbox v-model="dataObject.noRanking" :disabled="dataObject.isCup"
                        label="keine Tabelle berechnen" color="primary">
            </v-checkbox>
            <error-msg :error="error"></error-msg>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "../../components/form/formContainer";
    import {FormRules} from "../../services/formRules";
    import ErrorMsg from "../../components/elements/errorMsg";

    export default {
        components: { ErrorMsg, FormContainer},
        name: "liga-edit",
        props: ['currentData', 'landesverband'],
        data: () => ({
            rules: null,
            dataObject: {
                id: null,
                name: '',
                nameFull: '',
                isCup: false,
                type: '',
                sort: 10,
                noRanking: false,
                keineDoppelstartKontrolle: false,
            },
            error: '',
        }),
        computed: {
            types(){ const types = JSON.parse(JSON.stringify(this.$store.state.local.ligaTypes.filter(
                type => type.type === 'Liga'
            )))
            return types;},
            title(){ return this.currentData ? 'Liga ändern' : 'Liga anlegen'},
        },
        created(){
            this.rules = new FormRules();
        },
        methods: {
            async save(){
                // check if name is unique
                    if ( !this.landesverband.isNotLigaNameDuplicate(this.dataObject) ) {
                        this.error = 'Diese Ligabezeichnung ist bereits vergeben, bitte wähle eine andere!';
                        return;
                    }
                // get unique id
                    if ( !this.dataObject.id ) {
                        this.dataObject.id = this.landesverband.getNextId();
                    }
                // save
                    this.landesverband.local.documentUpdates = {
                        ['ligen.' + this.dataObject.id]: {
                            name: this.dataObject.name,
                            nameFull: this.dataObject.nameFull,
                            isCup: this.dataObject.isCup,
                            type: this.dataObject.type,
                            sort: this.dataObject.sort,
                            noRanking: this.dataObject.noRanking,
                            keineDoppelstartKontrolle: this.dataObject.keineDoppelstartKontrolle,
                        },
                    };
                    this.$store.state.local.loader = true;
                    let reply = await this.landesverband.saveEdited();
                    if ( reply.successful ) {
                        if ( this.currentData ) {
                            this.$emit('changeLigaName', this.dataObject);
                        }
                        this.resetDataObject();
                        window.history.back();
                    }
                    this.$store.state.local.loader = false;
            },
            resetDataObject(){
                this.dataObject = {
                    id: null,
                    name: '',
                    nameFull: '',
                    isCup: false,
                    type: '',
                    sort: 10,
                    noRanking: false,
                    keineDoppelstartKontrolle: false,
                };
                this.error = '';
            },
            processCupSelection(){
                if ( this.dataObject.isCup ) {
                    this.dataObject.noRanking = true
                    this.dataObject.keineDoppelstartKontrolle = true
                } else {
                    this.dataObject.noRanking = false
                    this.dataObject.keineDoppelstartKontrolle = false
                }
            }
        },
        watch: {
            currentData(){
                if ( this.currentData ) {
                    this.dataObject = JSON.parse(JSON.stringify(this.currentData));
                    if ( this.dataObject.isCup === undefined ) this.dataObject.isCup = false
                    if ( this.dataObject.noRanking === undefined ) this.dataObject.noRanking = false
                    if ( this.dataObject.keineDoppelstartKontrolle === undefined ) this.dataObject.keineDoppelstartKontrolle = false;
                } else {
                    this.resetDataObject();
                }
            },
            'dataObject.isCup'(){
                this.processCupSelection()
            }
        }

    }
</script>

<style scoped>

</style>